import { DataGrid, GridColDef, GridRowsProp, GridValidRowModel, GridRowIdGetter } from "@mui/x-data-grid";
import DialogContent from '@mui/material/DialogContent';
import { BaseDialog } from '../dialog/BaseDialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { HeaderButton, HeaderButtons } from "./HeaderButtons";
import { Box } from "@mui/material";
import { SectionTitle } from "../Typography";


type Props<T extends GridValidRowModel> = {
  open: boolean;
  onClose: () => void;
  title: string;
  headerButtons?: HeaderButton[];
  children?: React.ReactNode;
  table: {
    data: GridRowsProp<T>;
    columns: readonly GridColDef<T>[];
    getRowKey: GridRowIdGetter<T>;
  }
}

export function DialogTable<T extends GridValidRowModel>({
  open,
  onClose,
  title,
  headerButtons,
  children,
  table
}: Props<T>) {
  const buttons = headerButtons || [];

  return (
    <BaseDialog open={open} onClose={onClose} aria-labelledby="log-dialog">
      <Box sx={{ display: "flex", m: 3, justifyContent: "space-between", alignItems: "center" }}>
        <SectionTitle title={title} />
        <Box>
          <HeaderButtons headerButtons={buttons} />
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <DialogContent sx={{ overflowY: 'auto' }}>
        <DataGrid
          rows={table.data}
          columns={table.columns}
          getRowId={table.getRowKey}
        />
        {children}
      </DialogContent>
    </BaseDialog>
  );
}